import {Crown} from '@blesk-frontend/ui';

export const PlanProBadge = () => (
  <div className="flex h-5 items-center gap-1 rounded-md bg-brand-primary px-2 py-1">
    <Crown className="size-3 flex-1 text-attention-primary" />
    <span className="font-semibold text-[10px] text-text-contrast">PRO</span>
  </div>
);
